import { Component, ViewChild, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
  BasicModalService,
  ModalConfig
} from '@cws-ui/ngx-cws-app-layout';
import { CwsRedirectService } from 'src/app/service/cws-redirect.service';
import { LogoutService } from 'src/app/service/logout.service';
import { common_urls } from 'src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-logout-button',
    templateUrl: './logout-button.component.html',
    styleUrls: ['./logout-button.component.scss'],
    standalone: true,
    imports: [TranslateModule],
})
export class LogoutButtonComponent {
  private cwsRedirectService = inject(CwsRedirectService);
  private logoutService = inject(LogoutService);
  private dialog = inject(MatDialog);
  private BasicModalService = inject(BasicModalService);

  @ViewChild('modalBody') modalBody: any;
  dialogConfig = new MatDialogConfig();


  openLogoutModal() {
    this.dialog.closeAll();
    const data: ModalConfig = {
      header: '',
      buttons: [
        {
          text: 'logout-modal.logoutBtn',
          result: OutputEvent.LOGOUT,
          classes: 'btn btn2',
        },
        {
          text: 'logout-modal.cancelBtn',
          result: OutputEvent.CANCEL,
          classes: 'btn btn3',
        },
      ],
      customBody: this.modalBody,
      customConfig: {
        autoFocus: true,
        restoreFocus: false
      },
      translate: true
    };
    this.BasicModalService.openModal(data).subscribe((result) => {
      console.log(`Dialog result: ${result}`);
      if (result === OutputEvent.LOGOUT) {
        this.logoutService.OIDClogout(
          `${common_urls.cwsBaseUrl}/secur/logout.jsp`
        );
      }
    })
  }

  openModal() {
    this.openLogoutModal();
    // this.openSurveyModal();
  }

  /* function to redirect user on cws */
  // redirectToCWS() {
  //   // this.inactivityService.stopTrackingInactivity();
  //   // // window.location.href = this.cwsBackUrl;
  //   // this.oidcSecurityService.logoffLocal();
  //   // console.log('local logoff called');

  //   // const url: string = sessionStorage.getItem('cwsBackUrl') || '';
  //   // window.open(decodeURIComponent(url), '_self');
  //   this.cwsRedirectService.redirectToCWSBack();
  // }

  /* Function to redirect user to procUrl (CWS procedure url page) */
  redirectToProcPage(): void {
    this.cwsRedirectService.redirectToCwsProcUrl();
  }
}
export enum OutputEvent {
  LOGOUT = 'logout',
  CANCEL = 'cancel',
  SURVEY = 'survey',
}
